module.exports = __webpack_public_path__ + "img/636511853776692269tegeltje.png";